import React, {useEffect} from 'react';
import { motion } from 'framer-motion';

import Header from '../components/Header';
import ProjectsRow from '../components/Project/ProjectsRow';
import About from "../components/About";
import ContactForm from "../components/ContactForm";

import Image from '../assets/home.webp';
import Specifications from '../components/Specifications/Specifications';
import People from '../components/People/PeopleList.json';

const Home = () => {
    useEffect(() => {
        document.title = "Zoty";
    });
    
    return (
        <motion.div
            initial={{ translateY: -50, scale: 1, opacity: 0 }}
            animate={{ translateY: 0, opacity: 1 }}
            exit={{ translateX: -50, opacity: 0 }}
            transition={{ duration: 0.6, ease: [0.43, 0.13, 0.23, 0.96] }}>
            <Header
                title="Zoty"
                tagline={ <><span className='underline'>Nick Nettleton</span> {" // "} Software Engineer specializing in web applications, mobile apps, and business sytems.</> } 
                image={Image}
                subtitle="ATLANTA, GEORGIA"
                id="home" />
            <section>
                <div className="container">
                    <p className="section-title">My Experience</p>
                    <Specifications dataset={People[0].stats} cols={4} />
                </div>
            </section>
            <ProjectsRow handles={["obsidian-csync", "zotycamera", "azimuth"]} />
            <About />
            <ContactForm />
        </motion.div>
    );
};

export default Home;